export default __webpack_public_path__ + "static/media/834647FB-014D-4DE2-BABC-30A11984E456_1_201_a.f8b38fbd.jpeg";